"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.executeWhenVisible = void 0;
const executeWhenVisible = async f => {
  if (!document.hidden) {
    await f();
    return;
  }
  const onVisibilityChange = async () => {
    if (document.hidden) return;
    window.removeEventListener("visibilitychange", onVisibilityChange);
    await f();
  };
  window.addEventListener("visibilitychange", onVisibilityChange);
};
exports.executeWhenVisible = executeWhenVisible;
//# sourceMappingURL=executeWhenVisible.js.map